import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login } from '@/api/auth';

interface Credentials {
  email: string;
  password: string;
  pinCode: string;
}

const saveAuthData = (userData: any) => {
  const response = userData;
  const expiry = Date.now() + 24 * 60 * 60 * 1000;
  const authData = JSON.stringify({
    token: response.accessToken,
    response,
    expiry,
  });
  localStorage.setItem('authData', authData);
};

export const signInAsync = createAsyncThunk(
  'auth/login',
  async (credentials: Credentials, { dispatch, rejectWithValue }) => {
    try {
      const response: any = await login(credentials as any);

      if (response && response.data && response.data.accessToken) {
        saveAuthData(response.data);
        return response.data;
      } else {
        if (response.error) {
          return rejectWithValue(response.error); // Handle invalid password or email
        } else {
          return rejectWithValue('Unknown error occurred');
        }
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  user: null,
  token: null,
  status: 'idle',
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.status = 'idle';
      state.error = null;
      localStorage.removeItem('authData');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(signInAsync.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload;
        state.token = action.payload.accessToken;
      })
      .addCase(signInAsync.rejected, (state, action) => {
        state.status = 'failed';
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
